import { Route, type RouteComponentProps } from 'react-router-dom';

// hooks
import { useMenuList, useUser } from 'hooks';

// enums
import { SplashLoader } from 'components';
import { UserRole } from 'enums';

interface ExtendedRouteProps {
  path: string;
  component: React.ComponentType<any>;
}

interface PrivateRouteProps extends ExtendedRouteProps {
  fallback: React.ComponentType<any>;
  isPermission: (role: UserRole | null) => boolean;
  exact?: boolean;
}

export const PrivateRoute = ({
  path,
  component: Component,
  fallback: Fallback,
  isPermission,
  exact = false
}: PrivateRouteProps) => {
  const { userRole } = useUser();
  const { flatMenuList, isLoading } = useMenuList();

  const checkRoute = (path: string) => {
    if (!path) return false;

    const asseccibleMenu = flatMenuList.some((menu) => menu.pgmUrl === path);

    return asseccibleMenu;
  };

  const handleRouting = (props: RouteComponentProps) => {
    if (isLoading) {
      return <SplashLoader />;
    }

    if (!checkRoute(path)) {
      return <Fallback {...props} />;
    }

    if (isPermission(userRole)) {
      return <Component {...props} />;
    } else {
      return <Fallback {...props} />;
    }
  };

  return <Route path={path} exact={exact} render={handleRouting} />;
};
